import React from 'react';
import {styled} from '@mui/material/styles';
import {motion} from 'framer-motion';
import {ComesInViewFrom, createVariants} from '../motions/MotionVariants';

interface ContentImageProps {
  imgHeight: number;
  imgWidth: number;
  imgSrc: string;
  imgAlt: string;
  fetchPriority?: string;
  lazy?: boolean;
  comesInViewFrom?: ComesInViewFrom;
  animationOnce?: boolean;
}

const ImageContainer = styled('div')<{imgHeight: ContentImageProps['imgHeight']}>`
  @media all and (max-width: 800px) {
    padding-top: 2rem;
    margin: auto;
  }

  img {
    max-height: ${(props) => props.imgHeight}px;
    height: auto;
    max-width: 100%;
    object-fit: contain;
    right: 0;
  }
`;

const ContentImage: React.FC<ContentImageProps> = ({
  imgHeight,
  imgWidth,
  fetchPriority = 'auto',
  imgSrc,
  imgAlt,
  lazy,
  comesInViewFrom,
  animationOnce = true,
}) => {
  // Using fetchpriority to optimize LCP - it is not supported by all browsers and not standardized yet
  // therefore we need to ignore type checking here

  const variants = comesInViewFrom
    ? createVariants(comesInViewFrom)
    : {
        offscreen: {opacity: 0, scale: 0.9},
        onscreen: {
          opacity: 1,
          scale: 1,
          transition: {
            duration: 1,
          },
        },
      };
  const amount = comesInViewFrom ? {amount: 0.5} : {};
  return (
    <ImageContainer imgHeight={imgHeight}>
      <picture>
        <source srcSet={`${imgSrc}.webp`} type='image/webp' />
        <motion.img
          initial='offscreen'
          whileInView='onscreen'
          variants={variants}
          viewport={{...amount, once: animationOnce}}
          // @ts-ignore
          fetchpriority={fetchPriority}
          loading={lazy ? 'lazy' : 'eager'}
          height={imgHeight}
          width={imgWidth}
          alt={imgAlt}
          src={`${imgSrc}.png`}
        />
      </picture>
    </ImageContainer>
  );
};

export default ContentImage;
